import script from "./AddToReturnBoxAppCompleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddToReturnBoxAppCompleteModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__